export const DEFAULT_EXPERIENCE_RUBRIC = 'DEFAULT';

export type ExperienceTenantIdentity = {
    code?: string;
    id?: number | string | null;
    experienceRubric?: string | null;
};

export function resolveExperienceTenantScope(
    tenant: ExperienceTenantIdentity | null | undefined,
    fallback = 'default',
): string {
    const code = tenant?.code?.trim();
    if (code) {
        return code;
    }
    if (tenant?.id != null) {
        return String(tenant.id);
    }
    return fallback;
}

/** Tenant experienceRubric (auth) wins over user rubric preference. */
export function resolveExperienceRubric(
    tenantExperienceRubric?: string | null,
    userRubric?: string | null,
    fallback = DEFAULT_EXPERIENCE_RUBRIC,
): string {
    const tenantRubric = tenantExperienceRubric?.trim();
    if (tenantRubric) {
        return tenantRubric;
    }
    const user = userRubric?.trim();
    if (user) {
        return user;
    }
    return fallback;
}
